webpackJsonp([3],{

/***/ 32:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(88),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(736)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(916),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e81c89b",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 45:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_polyfill__);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('round', function (value, decimals) {
    if (!value) {
        value = 0;
    }

    if (!decimals) {
        decimals = 0;
    }

    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    return value;
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(__WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* currentLang */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$moment = __WEBPACK_IMPORTED_MODULE_1_moment___default.a;

__webpack_require__(152).polyfill();
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a;

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_vue__["default"]);

/***/ }),

/***/ 450:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "LanguageLogin",
  data: function data() {
    return {
      endpoint: __WEBPACK_IMPORTED_MODULE_0__config__["f" /* domain */] + '/login/auth',
      langs: _transformToLanguages(__WEBPACK_IMPORTED_MODULE_0__config__["i" /* supportedLocales */])
    };
  },
  props: ['lang'],
  methods: {
    translate: function translate() {
      window.location.href = this.endpoint + '?lang=' + this.lang;
    }
  }
});

function _transformToLanguages(languages) {
  return languages.substring(1).slice(0, -1).replace(/ /g, '').split(',');
}

/***/ }),

/***/ 454:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LanguageLogin__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LanguageLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__LanguageLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Ihsvg__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Ihsvg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_Ihsvg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "TopbarLogin",
  data: function data() {
    return {
      name: '',
      lang: __WEBPACK_IMPORTED_MODULE_0__config__["a" /* currentLang */]
    };
  },

  components: {
    LanguageLogin: __WEBPACK_IMPORTED_MODULE_1__LanguageLogin___default.a,
    Ihsvg: __WEBPACK_IMPORTED_MODULE_2__common_Ihsvg___default.a
  },

  mounted: function mounted() {},

  computed: {
    mainUrl: function mainUrl() {
      return __WEBPACK_IMPORTED_MODULE_0__config__["f" /* domain */];
    }
  }
});

/***/ }),

/***/ 459:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_common_vue__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_i18n__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header_TopbarLogin__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_header_TopbarLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_header_TopbarLogin__);






/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0__components_common_vue__["a" /* default */]({
    el: '#topbar-login',
    template: '<TopbarLogin/>',
    components: {
        TopbarLogin: __WEBPACK_IMPORTED_MODULE_2__components_header_TopbarLogin___default.a
    },
    i18n: __WEBPACK_IMPORTED_MODULE_1__components_i18n__["a" /* default */]
});

/***/ }),

/***/ 46:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__messagesProvider_js__ = __webpack_require__(73);






var messages = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.merge(__WEBPACK_IMPORTED_MODULE_4__messagesProvider_js__["a" /* getMessages */].fromCore(), __WEBPACK_IMPORTED_MODULE_4__messagesProvider_js__["a" /* getMessages */].fromAdaptation());

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);
var i18n = new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
    locale: __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* currentLang */],
    messages: messages
});

/* harmony default export */ __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./cat.json": 67,
	"./en.json": 68,
	"./es.json": 69,
	"./eu.json": 70,
	"./pt.json": 71
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66;

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

module.exports = {"menu":{"dashboard":"D'un cop d'ull","admin":"Administració","profile":"Perfil","treatments":"Tractaments","medicalRecords":"Informes","qrCoder":"QR Emergències","accessCodes":"Comparteix el teu historial","carePlan":"Programes","challenge":"Fites personals","presettedChallenge":"Reptes col·lectius","routes":"Rutes","followUp":"Seguiment","diet":"Menús saludables","device":"Dispositius i braçalets","calendar":"Calendari","blog":"Blog de salut","medicalCenters":"Centres mèdics","doctorFinder":"Cita Online","mobileAccessKey":"També al teu mòbil"},"section":{"medicalrecord":"Historial mèdic","healthwellness":"Salut i benestar","services":"Serveis"},"language":{"es":"Esp","en":"Eng","cat":"Cat","pt":"Por","eu":"Eus"},"header":{"greetings":"Hola, ","config":"Configurar compte","history":"Històric d’accessos","languages":"Idiomes","help":{"title":"General","textTitle":"Introducció","text1":"<b>BeHealthy</b> és una plataforma online de serveis creada perquè puguis gestionar de manera personalitzada la teva salut i la d'aquelles persones que tens al teu càrrec. A qualsevol lloc i en qualsevol moment","text2":"Aprèn a tenir cura de la teva salut amb <b>BeHealthy</b>. Podràs tenir sempre accessible el teu historial mèdic actualitzat, fixar-te reptes personalitzats, realitzar el seguiment de les indicadors i mesures que afecten la teva salut, portar un registre de tractaments i malalties o accedir a consells de salut i nutrició. Tot això de manera fàcil i segura.","text3":"Comptes amb una ajuda específica a cada secció de la plataforma. Però si necessites ajuda, no dubtis a posar-te en contacte amb nosaltres a través de: <a href='mailto: mora.assegurances@morabanc.ad'> mora.assegurances@morabanc.ad </a>"}},"dashboard":{"activity":"La teva activitat","recomendations":"Et pot interesar (alguns dels textes poden aparèixer en castellà)"},"healthAge":{"healthAge":"L’edat de la teva salut","realAge":"La teva edat real"},"profile":{"title":"El meu perfil","complete":"Completar perfil","healthAge":"Edat de la salut","bannerText":"Vols saber quina és l'edat de la teva salut?","link":"Saber-ne més"},"gamification":{"points":"Total de punts"},"devices":{"title":"Els meus dispositius","add":"Afegir","bannerText":"Connecta un dispositiu per registrar la teva activitat diària","link":"Anar als meus dispositius"},"feed":{"title":"Blog","category":{"actividad-fisica":"Activitat física","salud":"Salut","bienestar":"Benestar","nutricion":"Nutrició","menu-saludable":"Menú saludable"}},"global":{"help":"Ajuda","close":"Tancar"},"progression-tag":{"chartY":{"monday":"Dilluns","tuesday":"Dimarts","weednesday":"Dimecres","thursday":"Dijous","friday":"Divendres","saturday":"Dissabte","sunday":"Diumenge"},"week-progress":"Progrés setmanal de passos","bannerText":"Anima't a registrar els passos que fas cada dia","link":"Registrar passos"},"collective-challenge-card":{"type":"Reptes col·lectius","buttonShow":"Veure Repte","buttonIamIn":"M’hi apunto!","signUpPeople":" persones apuntades","bannerText":"Ben aviat tindràs aquí tot el que necessites saber per portar una vida més saludable"},"daily-calorie-intake-card":{"title":"Consum de calories","caloriesConsumed":"kcal ingerides","caloriesBurn":"kcal gastades","bannerText":"Vols saber quantes calories cremes al dia?","link":"Emplena les teves dades"},"footer":{"disclaimer":"Avís legal","aboutUs":"Qui som","contact":"Contacte"}}

/***/ }),

/***/ 68:
/***/ (function(module, exports) {

module.exports = {"menu":{"dashboard":"At a glance","admin":"Administración","profile":"Profile","treatments":"Treatments","medicalRecords":"Records","qrCoder":"QR for emergencies","accessCodes":"Share history","carePlan":"Care plans","challenge":"Personal goals","presettedChallenge":"Collective challenges","routes":"Tracks","followUp":"Follow up","diet":"Healthy meals","device":"Devices and smartbands","calendar":"Calendar","blog":"Healthy tips","medicalCenters":"Medical staff","doctorFinder":"Appointment booking","mobileAccessKey":"Also for your mobile"},"section":{"medicalrecord":"Medical history","healthwellness":"Wellbeing","services":"Health services"},"language":{"es":"Esp","en":"Eng","pt":"Por","eu":"Bas"},"header":{"greetings":"Hello, ","config":"Settings","history":"Access history","languages":"Lenguages","help":{"title":"General","textTitle":"Introduction","text1":"<b>Morabanc</b> is an online platform of services, created so you can manage your health and the health of those in you care in a personalized way. Anywhere and anytime.","text2":"Learn to care for your health with Morabanc. You can have your updated medical history accessible, build your own personalized challenges, track measurements that affect your health, keep track of treatments and disease, access to health and nutrition advice..... All in an easy and secure way.","text3":"Accounts have specific help for each section of the platform. But if you need more, do not hesitate to contact us through: <a href='mailto:contact@inithealth.com?subject=Contact%20from%20web'>contact@inithealth.com</a>"}},"dashboard":{"activity":"Your activity","recomendations":"May interest you"},"healthAge":{"healthAge":"The age of your health","realAge":"Your biological age"},"profile":{"title":"Profile","complete":"Fill out profile","healthAge":"The age of your health","bannerText":"Do you want to know the age of your health?","link":"See more"},"gamification":{"points":"Health points"},"devices":{"title":"Devices and smartbands","add":"Add device","bannerText":"Connect a device to record your daily activity","link":"Show devices"},"feed":{"title":"Healthy tips","category":{"actividad-fisica":"Physical activity","salud":"Health","bienestar":"Wellbeing","nutricion":"Nutrition","menu-saludable":"Healthy meals"}},"global":{"help":"Help","close":"Close"},"progression-tag":{"chartY":{"monday":"Monday","tuesday":"Tuesday","weednesday":"Wednesday","thursday":"Thursaday","friday":"Friday","saturday":"Saturday","sunday":"Sunday"},"week-progress":"Weekly progress on steps","bannerText":"Encourage yourself to record your everyday steps","link":"Record steps"},"collective-challenge-card":{"type":"Collective challenges","buttonShow":"More info","buttonIamIn":"Let´s join","signUpPeople":" registered people","bannerText":"Soon you would have all you need to know to have a more healthy live style"},"daily-calorie-intake-card":{"title":"Wasted calories","caloriesConsumed":"Kcal. ingested","caloriesBurn":"Kcal. burned","bannerText":"Would you like to know how many calories you burn per day?","link":"Fill in your details"},"footer":{"disclaimer":"Legal disclaimer","aboutUs":"About us","contact":"Contact"}}

/***/ }),

/***/ 69:
/***/ (function(module, exports) {

module.exports = {"menu":{"dashboard":"De un vistazo","admin":"Administración","profile":"Perfil","treatments":"Tratamientos","medicalRecords":"Informes","qrCoder":"QR Emergencias","accessCodes":"Comparte tu historial","carePlan":"Programas","challenge":"Metas personales","presettedChallenge":"Retos colectivos","routes":"Rutas","followUp":"Seguimiento","diet":"Menús saludables","device":"Dispositivos y pulseras","calendar":"Calendario","blog":"Blog de salud","medicalCenters":"Centros médicos","doctorFinder":"Cita Online","mobileAccessKey":"También en tu móvil"},"section":{"medicalrecord":"Historial médico","healthwellness":"Salud y bienestar","services":"Servicios"},"language":{"es":"Esp","cat":"Cat","en":"Eng","pt":"Por","eu":"Eus"},"header":{"greetings":"Hola, ","config":"Configurar cuenta","history":"Histórico de accesos","languages":"Idiomas","help":{"title":"General","textTitle":"Introducción","text1":"<b>BeHealthy</b> es una plataforma online de servicios, creada para que puedas gestionar de forma personalizada tu salud y la de aquellas personas que se #encuentran a tu cuidado. En cualquier lugar y en cualquier momento","text2":"Aprende a cuidar tu salud con <b>BeHealthy</b>. Podrás tener tu historial médico actualizado accesible, construir tus propios retos personalizados, realizar un seguimiento de medidas y mediciones que afectan a tu salud, llevar un registro de tratamientos y enfermedades, acceder a consejos de salud y nutrición. Todo ello de una forma fácil y segura.","text3":"Cuentas con una ayuda específica en cada sección de la plataforma. Pero si necesitas más, no dudes en ponerte en contacto con nosotros a través de: <a href='mailto: mora.assegurances@morabanc.ad'> mora.assegurances@morabanc.ad </a>"}},"dashboard":{"activity":"Tu actividad","recomendations":"Te puede interesar"},"healthAge":{"healthAge":"La edad de tu salud","realAge":"Tu edad real"},"profile":{"title":"Mi perfil","complete":"Completar perfil","healthAge":"Edad de la salud","bannerText":"¿Quieres saber cuál es la edad de tu salud?","link":"Saber mas"},"gamification":{"points":"Total de puntos"},"devices":{"title":"Mis dispositivos","add":"Añadir","bannerText":"Conecta un dispositivo para registrar tu actividad diaria","link":"Ir a mis dispotivos"},"feed":{"title":"Blog","category":{"actividad-fisica":"Actividad física","salud":"Salud","bienestar":"Bienestar","nutricion":"Nutrición","menu-saludable":"Menú Saludable"}},"global":{"help":"Ayuda","close":"Cerrar"},"progression-tag":{"chartY":{"monday":"Lunes","tuesday":"Martes","weednesday":"Miercoles","thursday":"Jueves","friday":"Viernes","saturday":"Sabado","sunday":"Domingo"},"week-progress":"Progreso semanal de pasos","bannerText":"Ánimate a registrar tus pasos andados cada día","link":"Registrar pasos"},"collective-challenge-card":{"type":"Retos colectivos","buttonShow":"Ver Reto","buttonIamIn":"¡Me apunto!","signUpPeople":" personas apuntadas","bannerText":"En breve tendrás aquí todo lo que necesitas saber para llevar una vida más saludable"},"daily-calorie-intake-card":{"title":"Consumo de calorias","caloriesConsumed":"Kcal. Ingeridas","caloriesBurn":"Kcal. Gastadas","bannerText":"¿Quieres saber cuantas calorías quemas al día?","link":"Rellena tus datos"},"footer":{"disclaimer":"Aviso Legal","aboutUs":"Quiénes somos","contact":"Contacto"}}

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return domain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return cdnUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return apiDomain; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return blogUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return inutraliaURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return defaultChallenge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return currentLang; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return supportedLocales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return showScoreCard; });
var domain = window.inithealth.config.mainDomain;
var cdnUrl = window.inithealth.config.cdnUrl;
var apiDomain = domain + '/api';
var blogUrl = domain + '/blog/post/';
var inutraliaURL = domain + '/diet/recipe/';
var defaultChallenge = 10000;
var currentLang = window.inithealth.config.lang ? window.inithealth.config.lang.split('_')[0] : 'es';
var supportedLocales = window.inithealth.config.supportedLocales;
var showScoreCard = eval(window.inithealth.config.showScoreCard || true);

/***/ }),

/***/ 70:
/***/ (function(module, exports) {

module.exports = {"menu":{"dashboard":"Begiratu batean","admin":"Administrazio-panela","profile":"Nire profila","treatments":"Nire tratamenduak","medicalRecords":"Nire txostenak","qrCoder":"Larrialdietarako QR","accessCodes":"Partekatu zure historia","carePlan":"Osasun plangintza","challenge":"Nire helburuak","presettedChallenge":"Gure erronkak","routes":"Nire ibilbideak","followUp":"Nire jarraipena","diet":"Nire menu osasuntsuak","device":"Nire gailuak","calendar":"Nire egutegia","blog":"Bloga","medicalCenters":"Osasun zentroak","doctorFinder":"Online zita","mobileAccessKey":"Zue mugikorrean ere"},"section":{"medicalrecord":"Nire historia medikoa","healthwellness":"Osasuna eta ongizatea","services":"Serbitzuak"},"language":{"es":"Gaz","en":"Ing","pt":"Por","eu":"Eus"},"header":{"greetings":"Kaixo ","config":"Konfiguratu kontua","history":"Sartzeen historikoa","languages":"Idiomas","help":{"title":"Sarrera","textTitle":"Sarrera","text1":"<b>Morabanc</b> zerbitzu-plataforma bat da, zure eta zure zaintzapean dauden pertsonen osasuna modu pertsonalizatuan kudeatu ahal izateko sortutakoa. Edonon eta edonoiz.","text2":"Ikasi zure osasuna zaintzen Morabanc-ekin. Zure historia medikoa eguneratuta eta eskuragarri eduki ahal izango duzu, zuretzako erronka pertsonalizatuak ezarri ahal izango dituzu, zure osasunean eragina duten neurri eta neurketen jarraipena egin ahal izango duzu, tratamenduen eta gaixotasunen erregistroa egin ahal izango duzu, osasunari eta nutrizioari buruzko gomendioak eskuratu... hori guztia modu erraz eta seguruan.","text3":"Plataformako atal bakoitzean laguntza zehatza daukazu eskuragarri. Hala ere, laguntza gehiago behar baduzu, jarri gurekin harremanetan helbide honetan: <a href='mailto:contact@inithealth.com?subject=Contact%20from%20web'>contact@inithealth.com</a>"}},"dashboard":{"activity":"Zure ariketak","recomendations":"Zuretzako"},"healthAge":{"healthAge":"Zure osasunaren adina","realAge":"Zure adina"},"profile":{"title":"########Mi perfil########","complete":"########Completar perfil########","healthAge":"########Edad de la salud########","bannerText":"Zure osasunaren adina jakin nahi duzu?","link":"Gehiago jakin"},"gamification":{"points":"Puntual guztira"},"devices":{"title":"Gailu eta eskumuturrekoak","add":"Gehitu gailu bat","bannerText":"Konektatu gailu bat zure eguneroko jarduera gordetzeko","link":"Ikusi nire gailuak"},"feed":{"title":"Blog","category":{"actividad-fisica":"Jarduera fisikoa","salud":"Osasuna","bienestar":"Ongizatea","nutricion":"Elikadura","menu-saludable":"Osasuntsu menua"}},"global":{"help":"Laguntza","close":"Itxi"},"progression-tag":{"chartY":{"monday":"Astelehena","tuesday":"Asteartea","weednesday":"Asteazkena","thursday":"Osteguna","friday":"Ostirala","saturday":"Larunbata","sunday":"Igandea"},"week-progress":"Aurrerapena","bannerText":"Egunean zehar ibiltzen dituzun pausuak gordetzen anima zaitez","link":"Asteko pausu hobekuntza"},"collective-challenge-card":{"type":"Gure erronkak","buttonShow":"Informazio gehiago","buttonIamIn":"Apuntatzen naiz","signUpPeople":" pertsonak izena eman dute","bannerText":"Laster hemen izango duzu bizitza osasuntzu bat eramateko jakim behar duzun guztia"},"daily-calorie-intake-card":{"title":"Kaloria kontsumoa","caloriesConsumed":"Irentsitako kalori kopurua","caloriesBurn":"Erabilitako kalori kopurua","bannerText":"Egunean zehar erretzen duzun kalori kopurua jakin nahi duzu?","link":"Zure datuak bete"},"footer":{"disclaimer":"Lege oharra","aboutUs":"Nor gara","contact":"Kontaktua"}}

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

module.exports = {"header":{"greetings":"Olá, ","config":"Configurar conta","history":"Histórico de acessos","languages":"Línguas","help":{"title":"Geral","textTitle":"Introdução","text1":"A <b>Oximesa</b> é uma plataforma de serviços criada para que possa gerir de forma personalizada a sua saúde e a das pessoas a seu cargo. Em qualquer lugar e a qualquer momento","text2":"Aprenda a cuidar da sua saúde com a <b>oximesa</b>. Poderá ter o seu registo de saúde atualizado acessível, construir os seus próprios desafios personalizados, acompanhar medidas e medições que afetam a sua saúde, manter um registo de tratamentos e doenças, aceder a conselhos de saúde e nutrição.....Tudo isso de uma forma fácil e segura.","text3":"Dispõe de uma ajuda específica em cada secção da plataforma. Mas se precisar de mais, não hesite em contactar-nos através de: <a href='mailto:contact_oximesa@praxair.com?subject=Contact%20from%20web'>contact_oximesa@praxair.com</a> o para o número de apoio ao paciente: 902 21 23 33"}},"language":{"es":"Esp","en":"Eng","pt":"Por"},"menu":{"dashboard":"Num relance","admin":"Administração","profile":"Perfil","treatments":"Tratamentos","medicalRecords":"Relatórios","qrCoder":"QR Emergências","accessCodes":"Partilhe o seu registo de saúde","presettedChallenge":"Desafios coletivos","carePlan":"Programas","challenge":"Objetivos pessoais","routes":"Itinerários","followUp":"Acompanhamento","diet":"Menus saudáveis","device":"Dispositivos e pulseiras","calendar":"Calendário","medicalCenters":"Centros de saúde","doctorFinder":"Consulta Online","mobileAccessKey":"Também no seu telemóvel","blog":"Blog de saúde"},"section":{"medicalrecord":"Registo de saúde","healthwellness":"Saúde e bem-estar","services":"Serviços"},"dashboard":{"activity":"A sua atividade","recomendations":"Pode ser de seu interesse"},"healthAge":{"healthAge":"A idade da sua saúde","realAge":"A sua idade real"},"profile":{"title":"O meu perfil","complete":"Completar perfil","healthAge":"Idade da sua saúde","bannerText":"Quer saber qual a idade da sua saúde?","link":"Ler mais"},"gamification":{"points":"Total de pontos"},"devices":{"title":"Os meus dispositivos","add":"Adicionar","bannerText":"Ligue um dispositivo para registar a sua atividade diária","link":"Ir para os meus dispositivos"},"feed":{"title":"Blogue","category":{"actividad-fisica":"Atividade física","salud":"Saúde","bienestar":"Bem-estar","nutricion":"Nutrição","menu-saludable":"Menu Saudável"}},"global":{"help":"Ajuda","close":"Fechar"},"progression-tag":{"chartY":{"monday":"Segunda-feira","tuesday":"Terça-feira","weednesday":"Quarta-feira","thursday":"Quinta-feira","friday":"Sexta-feira","saturday":"Sábado","sunday":"Domingo"},"week-progress":"Progresso semanal de passos","bannerText":"Registe os seus passos andados a cada dia","link":"Registar passos"},"collective-challenge-card":{"type":"Desafios coletivos","buttonShow":"Ver Desafio","buttonIamIn":"Quero inscrever-me","signUpPeople":"Pessoas inscritas","bannerText":"Em breve encontrará aqui tudo o que precisa de saber para levar uma vida mais saudável"},"daily-calorie-intake-card":{"title":"Consumo de calorias","caloriesConsumed":"Kcal. Ingeridas","caloriesBurn":"Kcal. Gastas","bannerText":"Quer saber quantas calorias queima por dia?","link":"Preencha os seus dados"},"footer":{"disclaimer":"Aviso Legal","aboutUs":"Quem somos","contact":"Contacto"}}

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(7);
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'ihsvg',
    data: function data() {
        return {
            svg: ''
        };
    },
    props: ['src'],
    mounted: function mounted() {
        var _this = this;

        var url = __WEBPACK_IMPORTED_MODULE_0__config__["d" /* cdnUrl */] + this.src;
        this.$http.get(url).then(function (response) {
            return _this.svg = response.data;
        });
    },

    computed: {
        url: function (_url) {
            function url() {
                return _url.apply(this, arguments);
            }

            url.toString = function () {
                return _url.toString();
            };

            return url;
        }(function () {
            return url = __WEBPACK_IMPORTED_MODULE_0__config__["d" /* cdnUrl */] + this.src;
        })
    }
});

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMessages; });

/*
require.context and the try catch is parsed in building (webpack) time.
It has to receive js literals (the string can not be dynamic (no var, no argument) and
the try catch has to be wrapping de call.
 */
var retrieveCoreContext = function retrieveCoreContext() {
    try {
        return __webpack_require__(66);
    } catch (e) {
        console.log(e);
    }
};

var retrieveAdaptationContext = function retrieveAdaptationContext() {
    try {
        return !(function webpackMissingModule() { var e = new Error("Cannot find module \"../../../../../custom/i18n\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
    } catch (e) {
        console.log(e);
    }
};

var withContext = function withContext(retrieveContext) {
    return function (func) {
        return function (languageDir) {
            return func(retrieveContext());
        };
    };
};

var getCustomMessages = function getCustomMessages(context) {
    return context ? extractMessagesFromContext(context) : {};
};
var languageCodeFrom = function languageCodeFrom(fileName) {
    return fileName.slice(2, -5);
};

var extractMessagesFromContext = function extractMessagesFromContext(context) {
    return context.keys().reduce(function (languages, fileName) {
        languages[languageCodeFrom(fileName)] = context(fileName);
        return languages;
    }, {});
};

var getMessages = {
    fromCore: withContext(retrieveCoreContext)(getCustomMessages),
    fromAdaptation: withContext(retrieveAdaptationContext)(getCustomMessages)
};

/***/ }),

/***/ 736:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 738:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 88:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.svg)
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(738)
}
var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(928),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-d3ce01be",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 916:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": ""
    }
  }, [_c('div', {
    staticClass: "topbar",
    attrs: {
      "data-dropdown": "dropdown",
      "id": "mytopbar"
    }
  }, [_c('div', {
    staticClass: "topbar-inner",
    staticStyle: {
      "background-image": "none"
    }
  }, [_c('div', {
    staticClass: "customerlogo"
  }, [_c('a', {
    attrs: {
      "href": _vm.mainUrl,
      "title": "Inicio"
    }
  }, [_c('span')])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-right"
  }, [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li', {
    staticClass: "top-languages",
    attrs: {
      "id": "languageSelector"
    }
  }, [_c('language-login', {
    attrs: {
      "lang": this.lang
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),

/***/ 928:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "language-selector-container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lang),
      expression: "lang"
    }],
    staticClass: "language-selector form-control small",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.lang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.translate]
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('header.languages')))]), _vm._v(" "), _vm._l((_vm.langs), function(lg) {
    return _c('option', {
      domProps: {
        "value": lg
      }
    }, [_vm._v(_vm._s(_vm.$t('language.' + lg)))])
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "caret"
  })])
},staticRenderFns: []}

/***/ })

},[459]);


// WEBPACK FOOTER //
// headerauth.js